import { Box, Tooltip } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { styled } from "@mui/material/styles";

export interface ReadUnreadBtnProps {
	/* on click event handler */
	onClick?: (e: React.MouseEvent<HTMLElement>) => void;

	/* true if unread */
	isUnread?: boolean;
}

const ButtonBox = styled(Box)(() => ({
	position: "absolute",
	right: 0,
	top: "50%",
	marginTop: -16,
	zIndex: 100,
	width: 32,
	height: 32,
}));

const OuterCircle = styled(Box)(() => ({
	border: "2px solid grey",
	borderRadius: "50%",
	width: 16,
	height: 16,
	position: "absolute",
	top: 8,
	right: 12,
}));

const InnerCircle = styled(Box)(() => ({
	width: 8,
	height: 8,
	borderRadius: "50%",
	background: "grey",
	position: "absolute",
	top: 12,
	right: 16,
}));

const ReadUnreadBtn: FunctionComponent<ReadUnreadBtnProps> = (props) => {
	const { isUnread, onClick } = props;

	const _onClick = (e: React.MouseEvent<HTMLElement>) => {
		onClick?.(e);
		e.stopPropagation();
		e.preventDefault();
	};

	return (
		<Tooltip placement="left" res={isUnread ? "NotificationMarkAsRead" : "NotificationMarkAsUnread"}>
			<ButtonBox className={(isUnread ? "csi-unread " : "") + "csi-read-unread-btn"} onClick={_onClick}>
				<OuterCircle className="csi-read-unread-outer" />
				<InnerCircle className="csi-read-unread-inner" />
			</ButtonBox>
		</Tooltip>
	);
};

export default ReadUnreadBtn;